import config from "../../config";
import logger from "../../utils/logger";


export const handleShare = async (formationId) => {


  const formationLink =
    // `${config.REACT_APP_ADMIN_URL}/FormationInfo/${formationId}`;
    `${window.location.origin}/FormationInfo/${formationId}`;




  await navigator.clipboard.writeText(formationLink);

  const encodedLink = encodeURI(formationLink);

  logger.debug('nuevo encodedLink: ', encodedLink)

  const whatsappLink =
    `https://api.whatsapp.com/send?text=${encodedLink}`;

 
  // window.location.href = whatsappLink;
  window.open(whatsappLink, '_blank', 'noopener,noreferrer')
};